<template>
  <div class="container">
    <shoutouts-programs-header-buttons
      :program="program"
      :tags="committedTags"
    />
    <shoutouts-programs-tabs class="m-bx4" initial-tab-value="tags" />
    <donut-alert
      v-if="upgradeRequired"
      :message="upgradeAlertMessage"
      :paywall="paywall"
      class="m-b-x2"
    />
    <div class="f f-gap-48 f-as pos-rel m-tx7">
      <div style="flex-basis: 350px">
        <shoutouts-tags-help-text />
      </div>
      <div class="flexed">
        <shoutouts-tags-form :initial-tags="tags" :upgrade-required="upgradeRequired" />
      </div>
      <div v-if="upgradeRequired" class="pos-abs h-100p w-100p left-0 top-0 bg-white o-50" />
    </div>
  </div>
</template>

<script setup>
import { computed, inject, onBeforeMount } from 'vue';
import { useStore } from 'vuex';

import { initCommittedTags, committedTags } from './module';

const props = defineProps({
  program: { type: Object, required: true },
  tags: { type: Array, required: true },
});
const $i18n = inject('$i18n');
const { commit, getters } = useStore();

// Paywalling
const featureTitleText = `add company values to ${$i18n.t('shoutouts.feature')}`;
const paywall = computed(() => ({
    data: props.program.upgrade_data,
    feature: 'tags',
    featureTitleText,
    source: 'shoutouts-values-info-block',
    programKey: 'shoutouts',
  }));
const upgradeRequired = computed(() => getters.upgradeRequired(paywall.value));
const upgradeAlertMessage = computed(() => {
  if (upgradeRequired.value) {
    const tagCount = props.program.tag_count;
    const tagCountPhrase = tagCount > 1 ? `${tagCount} existing values` : 'existing value';
    const suffix = tagCount ? `unlock your ${tagCountPhrase} and add more.` : featureTitleText;
    return `This feature is only available for ${props.program.upgrade_data.tags.plan} accounts. Upgrade to ${suffix}`;
  }
});

onBeforeMount(() => {
  // Hydrating vuex state module with program data for shoutouts-programs-modals-launch-announcement
  commit('update', {
    module: 'shoutoutsProgram',
    key: 'program',
    value: props.program,
  });
  initCommittedTags(props.tags);
});
</script>
